import { IconProps } from 'utils/global.types';

export const PlusInSquare = (props?: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="200"
    height="200"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
    <path d="M12 8L12 16"></path>
    <path d="M8 12L16 12"></path>
  </svg>
);
